import React, { Component } from 'react';
import { Collapse, Space } from 'antd';
import { withTranslation } from 'react-i18next'; // สมมติว่าใช้ library นี้

class Learn extends Component {
    render() {
        const { t } = this.props; // ฟังก์ชันสำหรับเรียกใช้คำแปล

        const items = [
            {
                key: '1',
                label: t('learn.step1.label'),
                children: (
                    <ul style={{ fontWeight: "500" }}>
                        <li>{t('learn.step1.detail')}</li>
                    </ul>
                ),
            },
            {
                key: '2',
                label: t('learn.step2.label'),
                children: (
                    <ul style={{ fontWeight: "500" }}>
                        <>
                            <em className='d-block'>* <u>{t('learn.step2.note1')}</u></em>
                            <em>{t('learn.step2.note2')}</em>
                        </>
                        <li className='mt-3'>
                            {t('learn.step2.action')}
                        </li>
                    </ul>
                ),
            },
            {
                key: '3',
                label: t('learn.step3.label'),
                children: (
                    <ul style={{ fontWeight: "500" }}>
                        <li>{t('learn.step3.action1')}</li>
                        <li className='mt-3'>{t('learn.step3.action2')}</li>
                        <li className='mt-3'>{t('learn.step3.action3')}</li>
                    </ul>
                ),
            },
            {
                key: '4',
                label: t('learn.step4.label'),
                children: (
                    <ul>
                        <li>{t('learn.step4.detail1')}</li>
                        <li className='mt-3'>{t('learn.step4.detail2')}</li>
                    </ul>
                ),
            },
        ];

        return (
            <div className=''>
                <h5 className="text-darkblue p-0 mx-3 mt-1 mb-3 ">
                    {t('learn.title')}
                </h5>
                <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
                    <Collapse className='w-100' accordion items={items} />
                </Space>
            </div>
        );
    }
}

// ใช้ High Order Component ครอบเพื่อส่งฟังก์ชัน t เข้าไปใน props ของ Class
export default withTranslation()(Learn);